import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { WindowRefService } from 'src/app/services/window/window.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})

export class AuthService {
  // Page related config
  userDetails = new BehaviorSubject<any>({});
  window: any = Window;
  destroySubject$: Subject<void> = new Subject();

  constructor(
    private http: HttpClient,
    private windowRef: WindowRefService,
    private cookieService: CookieService
  ) {
    this.window = this.windowRef.nativeWindow;
  }

  // Get User Details
  getProfileData(): Observable<any> {
    if (this.window.location.pathname?.match("/launchwiseapplication")) {
      return this.wiseWithoutrclc();
    } else {
      const agentCookie = this.window.location.hostname === 'localhost' ? true : this.cookieService.get('agentCookie');
      const channelPartnerFlag = this.window.location.pathname?.includes("wisechannelpartner") ? true : false;
      const path = !channelPartnerFlag ? "/wise-services/core/agent/getCachedUserDetails" :
        "/wise-services/core/partner/getCachedCpUserDetails";
      if (!channelPartnerFlag) {
        this.cookieService.delete('cpPfp', '/', this.window.location.hostname);
        this.cookieService.delete('cpBrowser', '/', this.window.location.hostname);
      }
      if (agentCookie) {
        return this.http.get(`${path}?email=${agentCookie}`)
          .pipe(map((res: any) => {
            localStorage.setItem("email", res.data.user.email);
            this.userDetails.next(res.data);
            return true;
          }),
          ).pipe(catchError((err) => {
            console.log('Caught in getUserDetails CatchError', err);
            return this.redirectToPingIdLogin();
          })
          )
      } else {
        console.log('Caught in Cookie CatchError');
        return this.redirectToPingIdLogin();
      }
    }
  }

  // Redirection to Ping ID Login Page - If user is 401 unauthorised
  redirectToPingIdLogin() {
    this.cookieService.delete('agentCookie', '/', this.window.location.hostname);
    localStorage.removeItem('agentType');
    localStorage.removeItem('contextKeyList');
    const channelPartnerFlag = this.window.location.pathname?.includes("wisechannelpartner") ? true : false;
    const encodeUrl = encodeURIComponent(this.window.location.href);
    const url = !channelPartnerFlag ? `/wise-services/core/authenticate?pageUrl=${encodeUrl}` :
      `/wise-services/core/launchWise/launchServiceNowChannelPartner/login?landingPageURL=${encodeUrl}`;
    this.window.location.href = url;
    return this.window.location.href;
  }

  wiseWithoutrclc() {
    const origin = this.window.location.origin;
    this.window.location.href = `${origin}/wise-services/core/launchWise`;
    return this.window.location.href;
  }

}
